// What analytics may know about a person. Email only once proven: anyone can
// attach someone else's address to a guest, and it must not land on a record.

import type { AuthUser } from "./source.ts";

export const personOf = (u: AuthUser): { email: string } | undefined =>
	u.verified && u.email ? { email: u.email } : undefined;
